
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Copy, CheckCircle2 } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface ProposalDisplayProps {
  proposal: string;
  isFallback: boolean;
}

const ProposalDisplay: React.FC<ProposalDisplayProps> = ({ proposal, isFallback }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { toast } = useToast();

  if (!proposal) return null;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(proposal);
    setIsCopied(true);
    toast({
      title: "Copied to clipboard",
      description: "The proposal has been copied to your clipboard.",
    });
    
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div>
          <div className="flex items-center gap-2">
            <CardTitle>Your Winning Proposal</CardTitle>
            {isFallback && (
              <div className="rounded-full bg-yellow-100 text-yellow-800 text-xs px-2 py-1">
                Fallback
              </div>
            )}
          </div>
          <CardDescription>
            Personalize this proposal before sending it to the client.
          </CardDescription>
        </div>
        <Button 
          variant="outline" 
          size="icon" 
          onClick={copyToClipboard}
          className="ml-auto"
          title="Copy to clipboard"
        >
          {isCopied ? (
            <CheckCircle2 className="h-4 w-4 text-green-500" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </Button>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border bg-muted/50 p-4 whitespace-pre-wrap">
          {proposal}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProposalDisplay;
